const slider = $('#module--before-after__wrapper__slider');
const afterImage = $('.module--before-after__wrapper__image--after');
const button = $('.module--before-after__wrapper__button');

// Listen to the slider input event
slider.on('input change', (e) => {
  updateSliderPosition(e.target.value);
});

// Listen to the mouse and touch events
slider.on('touchstart touchmove', (e) => {
 // e.preventDefault(); voorkomt scrollen
  const touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
  const sliderPos = calculateSliderPosition(touch.pageX);
  updateSliderPosition(sliderPos);
});

// Calculate the slider position based on the mouse position
function calculateSliderPosition(pageX) {
  const sliderRect = slider[0].getBoundingClientRect();
  const offsetX = pageX - sliderRect.left;
  const percentage = (offsetX / sliderRect.width) * 100;
  return Math.min(100, Math.max(0, percentage));
}

// Update the slider position and the image width
function updateSliderPosition(sliderPos) {
  const maxSliderPos = 100;
  sliderPos = Math.min(maxSliderPos, sliderPos);

  if(sliderPos == 1) {
    sliderPos = 0;
  }

  const imageWidth = sliderPos;
  afterImage.css('width', `${imageWidth}%`);
  button.css('left', `${sliderPos}%`);
}
